import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { dates } from 'investira.sdk';
import services from '../services';
import withResponseHandling from './withResponseHandling';
import withMessage from './withMessage';
import { acBackgroundArquivosChanged, acCarteirasChanged } from '../store/actions';
import usePrevious from '../hooks/usePrevious';
import { AVALIACAO_SESSOES } from '../enums';

const PAGE_SIZE = 25;

const withAvaliacoesSessoes = Component => {
  function WrapComponent(props) {
    const entidadeId = useSelector(state => state.entidade.current.default_entidade_id);
    const storeDispatch = useDispatch();

    const [avaliacoes, setAvaliacoes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);
    const [rowSelection, setRowSelection] = useState({});
    const [pagination, setPagination] = useState({
      pageIndex: 0,
      pageSize: PAGE_SIZE
    });

    function updateStore(pData) {
      storeDispatch(acCarteirasChanged(pData));
    }

    const readAvaliacoes = useCallback(
      (pParams = {}, pCallback) => {
        if (!avaliacoes.length) {
          setIsLoading(true);
        } else {
          setIsRefetching(true);
        }

        const xParams = {
          size: PAGE_SIZE,
          page: 1,
          sort: 'favorito desc, carteira',
          ...pParams
        };

        setTimeout(() => {
          setAvaliacoes(Object.values(AVALIACAO_SESSOES));
          setIsLoading(false);
          setIsRefetching(false);
        }, 1000);

        // services.avaliacoes.list(
        //   xParams,
        //   rRes => {
        //     setAvaliacoes(Object.values(rRes.data));
        //     setRowCount(rRes.pages.total_items);
        //     pCallback && pCallback(Object.values(rRes.data));
        //   },
        //   rErr => {
        //     props.responseErrorHandling(rErr);
        //   },
        //   () => {
        //     setIsLoading(false);
        //     setIsRefetching(false);
        //   }
        // );
      },
      [avaliacoes.length, props]
    );

    const deleteAvaliacoes = (pCarteiraId, onFinish) => {
      services.avaliacoes.remove(
        pCarteiraId,
        rRes => {
          props.onMessageSuccess('Avaliação excluída com sucesso');
          readAvaliacoes({}, updateStore);
          setRowSelection({});
        },
        rErr => {
          props.responseErrorHandling(rErr);
        },
        () => {
          onFinish && onFinish();
        }
      );
    };

    const bulkDeleteAvaliacoes = pRows => {
      const xAvaliacoesId = pRows.map(xRow => {
        const { avaliacao_id } = xRow.original;
        return avaliacao_id;
      });

      xAvaliacoesId.forEach(xId => {
        deleteAvaliacoes(xId);
      });
    };

    useEffect(() => {
      const xPage = pagination.pageIndex + 1;

      readAvaliacoes({
        page: xPage,
        size: pagination.pageSize
      });
    }, [readAvaliacoes, pagination.pageIndex, pagination.pageSize, entidadeId]);

    const xProps = {
      avaliacoes,
      isLoading,
      isRefetching,
      rowCount,
      rowSelection,
      pagination,
      setPagination,
      setRowSelection,
      readAvaliacoes,
      deleteAvaliacoes,
      bulkDeleteAvaliacoes
    };

    return <Component {...xProps} />;
  }

  return withMessage(withResponseHandling(WrapComponent));
};

export default withAvaliacoesSessoes;
